import { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import { Wand2 } from "lucide-react";
import { api, formatError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { ShareButtons } from "@/components/ShareButtons";
import { API } from "@/lib/api";

export default function MockupShare() {
  const { id } = useParams();
  const { user } = useAuth();
  const [s, setS] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    api.get(`/mockup-shares/${id}`).then((r) => {
      setS(r.data);
      document.title = `${r.data.pet_name} on a ${r.data.product_name} | Cutie Parlor`;
    }).catch((e) => setError(formatError(e)));
  }, [id]);

  if (error) return (
    <main className="max-w-lg mx-auto px-4 py-20 text-center" data-testid="mockup-share-not-found">
      <p className="font-display text-3xl font-bold">This mockup wandered off.</p>
      <Link to="/" className="mt-6 inline-block font-bold text-[#FF5A79]">Visit Cutie Parlor</Link>
    </main>
  );
  if (!s) return <div className="max-w-3xl mx-auto px-4 py-16"><div className="shimmer aspect-square rounded-3xl" /></div>;

  const text = `${s.pet_name} on a ${s.product_name}! Made with Cutie Parlor`;
  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-10 grid lg:grid-cols-12 gap-10 items-start" data-testid="mockup-share-page">
      <div className="lg:col-span-7 rounded-[2rem] bg-white sticker p-3 rise">
        <img src={s.mockup_url} alt={text} className="w-full rounded-3xl aspect-square object-cover" data-testid="mockup-share-image" />
      </div>
      <div className="lg:col-span-5 space-y-5">
        <p className="text-xs font-bold uppercase tracking-wider text-[#8A4FFF]">{s.product_name}{s.color ? ` · ${s.color}` : ""}</p>
        <h1 className="text-4xl sm:text-5xl font-bold tracking-tight" data-testid="mockup-share-title">{s.pet_name} is now <span className="text-[#FF5A79]">merch.</span></h1>
        <p className="text-[#6E687A]">{s.prompt_title} style, designed by {s.author}</p>
        <ShareButtons id={id} link={`${API}/sm/${id}`} text={text} title="Share this mockup" />
        <div className="rounded-3xl bg-[#FFC72C] sticker p-6">
          <h2 className="text-2xl font-bold">Put your pet on a {s.product_type === "tshirt" ? "tee" : s.product_type}</h2>
          <p className="mt-1 text-sm">From ${s.price.toFixed(2)}. Printed on demand and shipped to your door.</p>
          <Link to={user ? `/studio?prompt=${s.prompt_id}` : "/signup"} data-testid="mockup-share-cta"
            className="mt-4 inline-flex items-center gap-2 rounded-full bg-[#1E1B26] text-white px-5 py-2.5 font-bold text-sm hover:bg-[#FF5A79] transition-colors">
            <Wand2 className="h-4 w-4" /> Make my own
          </Link>
        </div>
      </div>
    </main>
  );
}
